import React from "react";
import talal from '../assets/talal.jpg';
import "./AboutUs.css";
import video from '../assets/talal.mp4'; // Import the video file


const AboutUs = () => {
  return (
    <div className="responsive-container-block bigContainer">
      <div className="responsive-container-block Container">
      
        <div className="responsive-container-block textSide">
          <p className="text-blk heading">Biology tutor at Future MedsAcademy</p>
          {/* <h2>My Journey and the Vision Behind Future MedsAcademy</h2> */}
          <p className="text-blk subHeading">
          Hi, I’m Talal Adil, and I’ll be your biology instructor at FutureMedsAcademy! I have been teaching sciences for over three years, with a strong focus on biology and chemistry. Last year, I started sharing my knowledge on YouTube, where I built a thriving community of students eager to learn. To make my lessons even more interactive, I expanded to live classes on Discord, helping students understand complex scientific concepts in a more engaging and accessible way.
Academically, I achieved 3 A*s and 2 As in my IGCSEs, followed by an A in both AS-Level Biology and Chemistry. Currently, I’m in my second year of university, pursuing a degree in Infrastructure Engineering. Despite my technical studies, my passion for biology has never faded—I continue to explore the subject as a personal interest, constantly learning and staying updated with new developments in the field. 
I’m excited to bring my teaching experience to FMA, and I look forward to helping you excel in biology!

          </p>
          {/* {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12"
            >
              <div className="cardImgContainer">
                <img
                  className="cardImg"
                  src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/id2.svg"
                  alt="Value Icon"
                />
              </div>
              <div className="cardText">
                <p className="text-blk cardHeading">Value</p>
                <p className="text-blk cardSubHeading">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </p>
              </div>
            </div>
          ))}
          <a href="#">
            <button className="explore">Read more</button>
          </a> */}
        </div>

        <div className="imgContainer">
          <img
            className="blueDots"
            src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/aw3.svg"
            alt="background dots"
          />
          <img
            className="mainImg"
            src={talal}
            alt="Main"
          />
                <h1>Talal Adil</h1>

             

        </div>
        <video
            className="mainVideo"
            controls
            autoPlay
            loop
            src={video}
            alt="Video"
          />
      


      </div>
    </div>
     );
    };
    
    export default AboutUs;